import React, { Component } from 'react';
import { Container } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import Footer from '../components/Footer';
import HeaderLocation from '../components/Header';

class Explorar extends Component {
  render() {
    return (
      <div className="page-wrapper-custom">
        <HeaderLocation title="Explorar" />
        <Container>
          <div className="text-center my-4">
            <h2 style={{ fontFamily: 'var(--font-display)', fontWeight: 800, fontSize: '2.2rem', color: 'var(--color-text)' }}>
              ✨ Descubra Novos Sabores
            </h2>
            <p style={{ color: 'var(--color-text-muted)', fontSize: '1.05rem', maxWidth: '500px', margin: '0 auto' }}>
              Escolha por onde deseja começar sua jornada gastronômica hoje: pratos elaborados ou coquetéis artesanais.
            </p>
          </div>

          <div className="d-flex flex-column flex-md-row justify-content-center align-items-stretch gap-4 my-5 mx-auto" style={{ maxWidth: '800px' }}>
            <Link
              data-testid="explore-food"
              to="/explorar/comidas"
              className="recipe-link flex-fill"
              style={{ textDecoration: 'none' }}
            >
              <div
                className="search-bar-card h-100 justify-content-between p-4 text-center"
                style={{
                  transition: 'transform 0.3s cubic-bezier(0.16, 1, 0.3, 1), box-shadow 0.3s ease',
                  cursor: 'pointer',
                  borderTop: '6px solid var(--color-primary)'
                }}
              >
                <div>
                  <div style={{ fontSize: '3.5rem', marginBottom: '16px' }}>🥘</div>
                  <h3 style={{ fontFamily: 'var(--font-display)', fontWeight: 700, fontSize: '1.6rem', color: 'var(--color-text)' }}>
                    Explorar Comidas
                  </h3>
                  <p style={{ color: 'var(--color-text-muted)', fontSize: '0.95rem', marginTop: '8px' }}>
                    Navegue por ingredientes frescos, origens regionais ou teste sua sorte com uma receita surpresa.
                  </p>
                </div>
                <div className="mt-4 pt-3 border-top d-flex align-items-center justify-content-center gap-2" style={{ color: 'var(--color-primary-dark)', fontWeight: 700 }}>
                  <span>Começar por pratos</span> &rarr;
                </div>
              </div>
            </Link>

            <Link
              data-testid="explore-drinks"
              to="/explorar/bebidas"
              className="recipe-link flex-fill"
              style={{ textDecoration: 'none' }}
            >
              <div
                className="search-bar-card h-100 justify-content-between p-4 text-center"
                style={{
                  transition: 'transform 0.3s cubic-bezier(0.16, 1, 0.3, 1), box-shadow 0.3s ease',
                  cursor: 'pointer',
                  borderTop: '6px solid var(--color-secondary)'
                }}
              >
                <div>
                  <div style={{ fontSize: '3.5rem', marginBottom: '16px' }}>🍸</div>
                  <h3 style={{ fontFamily: 'var(--font-display)', fontWeight: 700, fontSize: '1.6rem', color: 'var(--color-text)' }}>
                    Explorar Bebidas
                  </h3>
                  <p style={{ color: 'var(--color-text-muted)', fontSize: '0.95rem', marginTop: '8px' }}>
                    Descubra coquetéis clássicos, mocktails refrescantes e combinações únicas para acompanhar suas refeições.
                  </p>
                </div>
                <div className="mt-4 pt-3 border-top d-flex align-items-center justify-content-center gap-2" style={{ color: 'var(--color-secondary)', fontWeight: 700 }}>
                  <span>Começar por bebidas</span> &rarr;
                </div>
              </div>
            </Link>
          </div>
        </Container>
        <Footer className="footer orange" />
      </div>
    );
  }
}

export default Explorar;
